import React from "react";
import { useIncidentManagementEnabled } from "@/pages/IncidentManagement/featureFlag";
import NotFound404 from "@/pages/NotFound";

/**
 * Route guard for Incident Management, gated by the per-station WorkOS
 * `incident-management` flag AND the build-time incidents-API precondition
 * (see useIncidentManagementEnabled).
 *
 * Deliberately a guard rather than a conditional `<Route>`. WorkOS feature
 * flags aren't populated until the session finishes restoring, so on a hard
 * refresh `useIncidentManagementEnabled()` is briefly false. A route that is
 * only *registered* when the flag is on would therefore be absent during that
 * window, and the router would fall through to the catch-all 404 — flashing the
 * not-found page for a moment before the real page mounts. Keeping the path
 * always registered means the URL instead resolves to ProtectedView's loading
 * spinner while auth restores; only once loading has cleared (and the flag is
 * genuinely off) does a disabled station see the 404, preserving the prior
 * "disabled → 404" behavior.
 */
export function RequireIncidentManagement({
  children,
}: {
  children: React.ReactNode;
}) {
  const enabled = useIncidentManagementEnabled();
  if (!enabled) return <NotFound404 />;
  return <>{children}</>;
}
